import { ErrorBoundary } from '@sentry/react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import UnhandledError from './UnhandledError';

const AppErrorBoundary: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  return (
    <ErrorBoundary fallback={() => <UnhandledError />}>
      {children}
    </ErrorBoundary>
  );
};

export default AppErrorBoundary;
